import { Ng1StateDeclaration } from '@uirouter/angularjs';
import * as Resolve from '../Resolve';

import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'models',
        url: '/models',
        component: 'wtModelsState',
        abstract: false,
        resolve: {
            sharedState: () => { return {}; }
        },
        data: {
            displayName: 'Model',
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Model',
                level4: ''
            }
        }
    }, {
        name: 'models.structure',
        url: '/structure/:groupGuid',
        template: require('./structure/structure.html'),
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        params: {
            groupGuid: {
                value: '',
                squash: true
            }
        },
        data: {
            sortingOrder: 5, //5 for global menu on the left; 5 is also smaller than all the others
            visible: true,
            icon: 'fa-sitemap',
            displayName: 'Model',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => true,
            subMenu: {
                'type': 'groups',
                subState: 'group.trend',
                parentName: 'group'
            }
        }
    }, {
        name: 'models.identifiersMapping',
        url: '/identifiersMapping/:groupGuid?connectionPointGuid&searchMode',
        template: '<wt-identifiers-mapping-state class="flex-directive"></wt-identifiers-mapping-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        params: {
            groupGuid: {
                value: '',
                squash: true
            },
            connectionPointGuid: '',
            searchMode: ''
        },
        data: {
            sortingOrder: 100,
            visible: false,
            icon: 'fa-chain-broken',
            displayName: 'Tags mapping',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => true,
            subMenu: {
                'type': 'groups',
                subState: 'group.trend',
                parentName: 'group'
            }
        }
    }, {
        name: 'models.identifiers',
        url: '/identifiers/:groupGuid',
        template: '<wt-identifiers-page class="flex-directive" selected-identifier="vm.selectedIdentifier" selected-view-model="vm.selectedVM"></wt-identifiers-page>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        params: {
            groupGuid: {
                value: '',
                squash: true
            }
        },
        data: {
            sortingOrder: 200,
            visible: false,
            icon: 'fa-table',
            displayName: 'Identifiers',
            editRoles: [Roles.engineer, Roles.master],
            editButtonVisibility: () => true,
        }
    }, {
        name: 'models.alarms',
        url: '/alarms',
        template: '<wt-alarms-state class="flex-directive"></wt-alarms-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 300,
            visible: false,
            icon: 'fa-bell',
            displayName: 'Alarms',
            editRoles: [Roles.engineer, Roles.master],
            editButtonVisibility: () => false
        }
    }, {
        name: 'models.synchronization',
        url: '/synchronization/:groupGuid',
        template: '<wt-synchronization-state class="flex-directive"></wt-synchronization-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        params: {
            groupGuid: {
                value: '',
                squash: true
            }
        },
        data: {
            sortingOrder: 400,
            visible: false,
            icon: 'fa-retweet',
            displayName: 'Synchronization',
            editRoles: [],
            editButtonVisibility: () => false
        }
    }, {
        name: 'models.childApplications',
        url: '/childApplications',
        template: '<wt-children-comparison-page class="flex-directive"></wt-children-comparison-page>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 500,
            visible: false,
            icon: 'fa-external-link-square fa-rotate-90',
            displayName: 'Child applications',
            editRoles: [Roles.engineer, Roles.master],
            editButtonVisibility: () => false
        }
    }, {
        name: 'models.integrity',
        template: '<wt-model-integrity-state class="flex-directive"></wt-model-integrity-state>',
        url: '/integrity',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 600,
            visible: false,
            icon: 'fa-medkit',
            editButtonVisibility: () => false,
            displayName: 'Model integrity'
        }
    }, {
        name: 'models.history',
        template: '<wt-model-history-state class="flex-directive" is-store-loaded="vm.isStoreLoaded" begin-date="vm.beginDate" end-date="vm.endDate" states-dictionary="vm.statesDictionary" approval-strategies-dictionary="vm.approvalStrategiesDictionary" templates-dictionary="vm.templatesDictionary" validation-page-configurations-dictionary="vm.validationPageConfigurationsDictionary" groups-dictionary="vm.groupsDictionary" view-models-dictionary="vm.viewModelsDictionary" connection-points-dictionary="vm.connectionPointsDictionary" user-view-models="vm.userViewModels" is-async-store-loaded="!vm.isAsyncStoreLoading"></wt-model-history-state>',
        url: '/modelHistory?beginDate&endDate',
        params: {
            beginDate: '',
            endDate: ''
        },
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 700,
            visible: false,
            icon: 'fa-history',
            displayName: 'Model history',
            editRoles: [],
            editButtonVisibility: () => false
        }
    }, {
        name: 'models.statistics',
        template: '<wt-model-statistics-state class="flex-directive"></wt-model-history-state>',
        url: '/modelStatistics',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 800,
            visible: false,
            icon: 'fa-wpexplorer',
            displayName: 'Model statistics',
            editRoles: [],
            editButtonVisibility: () => false
        }
    }
];

export default states;